import { Navigate } from "react-router-dom";
import { registerAtom } from "./recoil/atoms";
import { useRecoilValue } from "recoil";

const RegisterRoute = ({ children }) => {
  const { username } = useRecoilValue(registerAtom);
  const isRefresh = username === null;

  if (isRefresh) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RegisterRoute;
